import { i18n } from "@pathwright/ui/src/components/lng/I18nextProvider"
import { NOTE_VISIBILITY_LEVELS } from "note/constants"

let NoteAddFormView
require("./styles/note-form.css")

const FilterMenu = require("lib/filter-menu/views/filter-menu").default

export default NoteAddFormView = (function () {
  NoteAddFormView = class NoteAddFormView extends (
    require("lib/static-shim").default(
      require("lib/uniform/views/form").default
    )
  ) {
    static initClass() {
      this.prototype.template = require("./templates/note-form.html")
      this.prototype.className = "pw-uniform note-form-view"

      this.prototype.ui = {
        addNote: ".add-note",
        input: ".note-form-input"
      }

      this.prototype.triggers = { "click .cancel-note": "cancel:note" }
    }

    behaviors() {
      const behaviors = super.behaviors()
      return _.extend(behaviors, {
        RichText: {
          container: ".note-panel-view"
        }
      })
    }

    initialize() {
      if (!this.model.isNew()) {
        return this.model.snapshot()
      }
    }

    onShow() {
      if (!this.model.isNew()) {
        return
      }
      if (this.options.filterData) {
        this.menu = new FilterMenu({
          model: new Backbone.Model(this.options.filterData),
          el: this.$(".filter-menu-view")
        })
        this.menu.render()

        return this.listenTo(this.menu, "filter:selected", (filter) => {
          const stepId = filter.get("id")
          window.App.getStore("note").action.setItem(stepId)
        })
      }
    }

    onRender() {
      return this.transitionView()
    }

    serializeData() {
      let data = super.serializeData()
      const global = this.serializeGlobal()
      data.author = global.user
      data.school_data = window.App.getStore("school").getState()
      data.shouldHaveSelect = this.model.isNew() && this.options.filterData
      data.action_label = i18n.t("notes.form.view.action", {
        action_label:
          (this.model.isNew() && i18n.t("notes.form.add")) ||
          i18n.t("notes.form.update")
      })
      data.isCurriculum =
        typeof context !== "undefined" && context !== null
          ? context.isCurriculum
          : undefined
      data.perms = window.App.getStore("note").request.getNotePermissions(
        this.model
      )
      data.visibility = NOTE_VISIBILITY_LEVELS
      data.rich_text_enabled = !App.request("ui:is:mobile")
      data.richTextOps = {
        nowrap: true,
        rt_config: "note",
        bind: "model:body",
        label: i18n.t("notes.form.view.your_note"),
        placeholder: i18n.t("notes.form.view.placeholder", {
          placeholder: this.options.placeholder
        })
      }
      return data
    }

    onCancelNote() {
      this.model.rollback()
      return this.destroy()
    }

    saveModel() {
      const isNew = this.model.isNew()
      this.trimAttributeValues()
      this.triggerMethod("before:model:save", this.model)
      const validationErrors = this.model.validate()
      if (!validationErrors)
        window.App.getStore("note")
          .action.saveNote(this.model.toJSON())
          .promise.then(this.onSave)
          .fail(this.onSaveFailed)
    }

    onModelSave() {
      this.model.set({ highlight: true })
      return this.triggerMethod("save:note", this.model)
    }

    transitionView() {
      return $.Velocity.animate(this.$el, "transition.slideRightIn", {
        duration: 350
      })
    }
  }
  NoteAddFormView.initClass()
  return NoteAddFormView
})()
